import type { FaireProductEntity } from "../../entity_types/product";

export const p_enrcc24jph: FaireProductEntity = {
  token: "p_enrcc24jph",
  type: "product",
  name: "Newborn Knotted Gown - Natalie",
  brandToken: "b_qba2f8n5gh",
  brandName: "Copper Pearl",
  imageUrl:
    "https://cdn.faire.com/fastly/00b59343c6506bc7c0d9394cf0b080a6934acd7ad50f6042cf11edef19883e86.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b29c819c3c3b48f8f48fb96bbbea5fb4613259293e6fdbb9a7b7cf20fb6773b9.jpeg",
    "https://cdn.faire.com/fastly/e761899decc8ca09c8921d323bbdd7a2d5d54c8eb3615c9efc16840f1b25a825.jpeg",
    "https://cdn.faire.com/fastly/f95d258b518fc6d33da42e3fee437481e4655b636958e7d9650a07e6a98c1e02.jpeg",
    "https://cdn.faire.com/fastly/1900cf5ac4ba87cc5e54add70376721223d441e75b7a58875ccd05746eb5553c.jpeg",
    "https://cdn.faire.com/fastly/545e512e705cebf2374ab1846feb1616742df4e96f486292b5e8082ad161450e.jpeg",
  ],
  priceDollars: 14,
  description:
    "\n * \nPREMIUM POLYESTER/RAYON BLEND – Made with the same premium knit fabric as our beloved swaddles, this soft and stretchy gown ties at the bottom for easy diaper changes—and has room to grow.\n\n * GENEROUS SIZE – A length of 25 inches and width of 8 inches. \n * \nBONUS FEATURES – Our knotted gowns feature unique snaps to make dressing a breeze, along with fold-over hand mitts to prevent scratching.\n\n * \nTRENDY, HIGH QUALITY DESIGNS – At Copper Pearl we pride ourselves on making high quality products that always look great on babies, moms, or in your nursery. Our knotted gowns are simple, modern, and sure to elevate any baby’s style.\n\n * \nPAIR PERFECTLY WITH COPPER PEARL PRODUCTS – Our trendy, newborn knotted gowns flaunt your favorite Copper Pearl prints and patterns. They are made to coordinate perfectly with products you already own and love!\n\n",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:17.035Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
